<template lang="pug">
.content.front.in-page
    Breadcrumb(:lstBreadcrumb="lstBreadcrumb")
    .box-lesson
        .container
            .col-md-3.col-sm-3.box-filter.collapse-filter(v-bind:class="[isOpenFilter ? 'open-collapse' : '']")
              .box-overlay-filter(@click="toggleFilter" v-bind:class="[isOpenFilter ? '' : 'collapse']")
              .box-filter-top
                  .title-filter 
                      span {{$t("page.filter.title")}}
                  input(:placeholder="$t('page.filter.keyword')" v-model="key_lesson" @keyup="onLessonChange")
                  .addons-button-clear(@click="onLessonClear" v-bind:style="clear_lesson ? 'display:block;' : 'display:none;' ")
                  button(@click="onLessonSearch") {{$t("page.filter.title")}}
              .box-filter-bottom
                  .close-filter
                    span.material-icons( @click="toggleFilter") clear
                  .title-filter
                      span {{$t("page.filter.for")}}
                  .remove-all(@click="removeAll" v-if="(lstSubjectIDs.length + lstGradeIDs.length) > 1")
                      img(src="../../../../assets/images/faces/ic_clear_24px.png" )
                      span {{$t("page.filter.remove_all")}}
                  .left-subjects.left-filter
                      .item-top
                          span.category {{$t("page.filter.subjects")}}
                          span.view-all(@click="viewAll(1)") {{$t("page.filter.view_all")}}
                      .item-checkbox(v-for="(subject, index) in lstSubjects" :class="(index < 10 || isActiveSubject) ? '' : 'collapse'")
                          input(type="checkbox" name="subjects" :id="'subjects_' + subject.id"  @click="onClickFilter($event, 1, subject.id)" :checked="lstSubjectIDs.includes(subject.id)")
                          label(:for="'subjects_' + subject.id")
                          span {{subject.name}}
                  .left-grades.left-filter
                      .item-top
                          span.category {{$t("page.filter.grades")}}
                          span.view-all(@click="viewAll(2)") {{$t("page.filter.view_all")}}
                      .item-checkbox(v-for="(grade, index) in lstGrades"  :class="(index < 10 || isActiveGrade) ? '' : 'collapse'")
                          input(type="checkbox" name="grades" :id="'grades_' + grade.id" :data-id="grade.id"  @click="onClickFilter($event, 2, grade.id)" :checked="lstGradeIDs.includes(grade.id)")
                          label(:for="'grades_' + grade.id")
                          span {{grade.name}}
            .col-md-9.col-sm-12.col-xs-12
              .box-search-custom
                input(:placeholder="$t('page.filter.keyword')" v-model="key_lesson" @keyup="onLessonChange")
                .addons-button-clear(@click="onLessonClear" v-bind:style="clear_lesson ? 'display:block;' : 'display:none;' ")
                button(@click="onLessonSearch") {{$t("page.filter.title")}}
                .icon-filter(v-bind:class="[isFilter ? 'icon-filter-point' : '']" @click="toggleFilter")
                  img(src="../../../../assets/images/faces/filter_list-24px.svg")
                  span {{$t("page.filter.tool_filter")}}
              .box-lesson-top
                .title {{$t("home.lesson.title")}}
              .box-lesson-content
                .row(id="containerId" ref="containerId"  v-if="lstLessons.length")
                  div(v-for="(lesson, index) in lstLessons")
                    FrontItem(:lesson="lesson" :key="count" :obj_id="lesson.id" ref="frontItem")
                  .clearfix
                .row(v-else)
                  .no-data.col-md-12.col-sm-12.col-xs-12 {{no_data}}
        .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import FrontItem from './Item.vue'
import Breadcrumb from '../../Breadcrumb'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification,
    FrontItem,
    Breadcrumb
  },
  data() {
    return {
      count: 0,
      loader: null,
      isActiveSubject: false,
      isActiveGrade: false,
      isLoadMore: false,
      isOpenFilter: false,
      isFilter: false,
      lstBreadcrumb: [],
      lstLessons: [],
      lstCounts: 0,
      key_lesson: '',
      clear_lesson: 0,
      lstSubjects: [],
      lstGrades: [],
      lstSubjectIDs: [],
      lstGradeIDs: [],
      limit: 20,
      currentPage: 1,
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    increment() {
      this.count++
    },
    onHome() {
      this.$router.push('/')
    },
    onBreadcrumb() {
      let lstPages = [
        {'name': '', 'title': this.$t('home.lesson.title')}
      ]
      this.lstBreadcrumb.push(lstPages)
    },
    removeAll() {
      this.lstSubjectIDs = []
      this.lstGradeIDs = []
      this.autoRefreshInfinite()
    },
    viewAll(type) {
      if (type === 1 && this.lstSubjects.length > 0) {
        this.isActiveSubject = true
      } else if (type === 2 && this.lstGrades.length > 0) {
        this.isActiveGrade = true
      }
    },
    onLessonSearch() {
      if (this.key_lesson.length > 0) {
        this.autoRefreshInfinite()
      }
    },
    onLessonChange(events) {
      if (events.key === 'Enter') {
        this.onLessonSearch()
      } else {
        if (this.key_lesson.length) this.clear_lesson = 1
        else this.onLessonClear()
      }
    },
    onLessonClear() {
      this.key_lesson = ''
      this.clear_lesson = 0
      this.autoRefreshInfinite()
    },
    onClickFilter(event, type, id) {
      if (type === 1) {
        if (event.target.checked) this.lstSubjectIDs.push(id)
        else this.lstSubjectIDs.splice(this.lstSubjectIDs.indexOf(id), 1)
      } else if (type === 2) {
        if (event.target.checked) this.lstGradeIDs.push(id)
        else this.lstGradeIDs.splice(this.lstGradeIDs.indexOf(id), 1)
      }
      // console.log('lstSubjectIDs', id, this.lstSubjectIDs, this.lstGradeIDs)
      this.autoRefreshInfinite()
    },
    autoRefreshInfinite() {
      this.lstLessons = []
      let objWhere = {
        type_lesson: {_eq: 1},
        is_public: {_eq: 2},
        is_complete: {_eq: true}
      }
      if (this.key_lesson.length > 0) {
        var $keyword = '%' + this.key_lesson + '%'
        objWhere = Object.assign(objWhere, {_or: [{name: {_ilike: $keyword}}, {fullname: {_ilike: $keyword}}]})
      }
      if (this.lstSubjectIDs.length > 0) {
        objWhere = Object.assign(objWhere, {subject_id: {_in: this.lstSubjectIDs}})
      }

      if (this.lstGradeIDs.length > 0) {
        objWhere = Object.assign(objWhere, {grade_id: {_in: this.lstGradeIDs}})
      }
      let variables = {
        where: objWhere,
        limit: this.currentPage * this.limit,
        offset: 0,
        orderBy: {
          updated_at: 'desc'
        }
      }

      this.$apollo.query({
        query: gql(graphql.GET_LESSONS_PAGE2),
        variables: variables
      }).then((response) => {
        this.lstLessons = response.data.v_front_lesson
      })
      // xoa item trong objects
      this.$delete(variables, 'offset')
      this.$delete(variables, 'limit')
      this.$apollo.query({
        query: gql(graphql.GET_LESSONS_PAGE2),
        variables: variables
      }).then((response) => {
        this.lstCounts = response.data.v_front_lesson.length
      })
      this.isFilter = (this.lstSubjectIDs.length + this.lstGradeIDs.length) > 0
      this.increment()
    },
    autoRefreshLoadMore() {
      let objWhere = {
        type_lesson: {_eq: 1},
        is_public: {_eq: 2},
        is_complete: {_eq: true}
      }
      if (this.key_lesson.length > 0) {
        var $keyword = '%' + this.key_lesson + '%'
        variables = Object.assign(variables, {_or: [{name: {_ilike: $keyword}}, {fullname: {_ilike: $keyword}}]})
      }
      if (this.lstSubjectIDs.length > 0) {
        variables = Object.assign(variables, {subject_id: {_in: this.lstSubjectIDs}})
      }

      if (this.lstGradeIDs.length > 0) {
        variables = Object.assign(variables, {grade_id: {_in: this.lstGradeIDs}})
      }
      let variables = {
        where: objWhere,
        limit: this.limit,
        offset: (this.currentPage - 1) * this.limit,
        orderBy: {
          updated_at: 'desc'
        }
      }
      this.$apollo.query({
        query: gql(graphql.GET_LESSONS_PAGE2),
        variables: variables
      }).then((response) => {
        let lstItem = response.data.v_front_lesson
        this.lstLessons = this.lstLessons.concat(lstItem)
      })
      this.increment()
      this.isLoadMore = false
      this.loader.hide()
    },
    onRefreshSubect(id) {
      if (!this.lstSubjectIDs.includes(id)) this.lstSubjectIDs.push(id)
      else this.lstSubjectIDs.splice(this.lstSubjectIDs.indexOf(id), 1)
      this.currentPage = 1
      this.autoRefreshInfinite()
    },
    onRefreshGrade(id) {
      if (!this.lstGradeIDs.includes(id)) this.lstGradeIDs.push(id)
      else this.lstGradeIDs.splice(this.lstGradeIDs.indexOf(id), 1)
      this.currentPage = 1
      this.autoRefreshInfinite()
    },
    pageChange(page) {
      this.currentPage = page
      this.autoRefreshLoadMore()
    },
    toggleFilter: function() {
      this.isOpenFilter = !this.isOpenFilter
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.3,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    handleScroll() {
      if (this.$route.params.front_top === undefined && this.$route.params.front_top) {
        let scrollTop = this.getScrollTop(window)
        let element = document.getElementById('containerId')
        if (element !== undefined && element !== null && this.$route.params.currentPage === undefined) {
          let clientHeight = element.clientHeight
          let windowHeight = window.innerHeight
          let pageCount = Math.ceil(this.lstCounts / this.limit)
          if (this.currentPage < pageCount && !this.isLoadMore && scrollTop + windowHeight > clientHeight) {
            this.isLoadMore = true
            this.show()
            this.currentPage++
            setTimeout(() => {
              this.autoRefreshLoadMore()
            }, 200)
          }
        }
      }
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    async getGrades() {
      var variables = {
        is_delete: {_eq: false},
        frontLesson: {
          type_lesson: {_eq: 1},
          is_public: {_eq: 2}
        }
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_GRADES_WHERE),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables,
          orderBy: {type_grade: 'asc', name: 'asc'}
        }
      }).catch((error) => {
        console.log('error', error)
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null) {
        this.lstGrades = data.grades
      }
    },
    async getSubjects() {
      var variables = {
        is_delete: {_eq: false},
        lessons: {
          type_lesson: {_eq: 1},
          is_public: {_eq: 2},
          is_delete: {_eq: false},
          is_complete: {_eq: true}
        }
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_SUBJECTS_WHERE),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables,
          orderBy: {name: 'asc'}
        }
      }).catch((error) => {
        console.log('error', error)
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null) {
        this.lstSubjects = data.subjects
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    if (this.$route.params.front_top === undefined) {
      window.scrollTo(0, 0)
    } else {
      setTimeout(() => {
        if (this.$route.params.front_top !== undefined && this.$route.params.front_top) {
          window.scrollTo(0, this.$route.params.front_top)
        }
      }, 100)
    }
  },
  async created() {
    this.onBreadcrumb()
    if (this.$route.params.subject_id !== undefined) {
      this.lstSubjectIDs.push(Number(this.$route.params.subject_id))
    }
    if (this.$route.params.grade_id !== undefined) {
      this.lstGradeIDs.push(Number(this.$route.params.grade_id))
    }
    if (this.$route.params.currentPage !== undefined && this.$route.params.currentPage) {
      this.currentPage = this.$route.params.currentPage
    }
    if (this.$route.query.keyword !== undefined && this.$route.query.keyword !== null) {
      this.key_lesson = this.$route.query.keyword
      this.clear_lesson = 1
    }
    await this.getGrades()
    await this.getSubjects()
    await this.autoRefreshInfinite()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.content.front.in-page{background: #FAFAFA;
    .box-lesson{margin-top:0; margin-bottom: 0px;
        .box-filter{margin-bottom: 20px;
           &.collapse-filter{position: relative;}
           .box-overlay-filter{display: none; background: #000000 0% 0% no-repeat padding-box;opacity: 0.5;width: 100%; position: fixed;top: 0;right: 0;height: 100%;}
           .box-filter-top{background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029; border: 1px solid #EFEFEF; padding: 15px;
              .title-filter{letter-spacing: 0.6px;color: #4B2D15; font-size: 20px; font-weight: bold;}
              input{margin: 15px 0; text-align: left;letter-spacing: 0px; color: #B4B4B4;background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4;border-radius: 10px; height: 48px; padding: 0 30px 0 10px; width: 100%;}
              input::placeholder{color: #B4B4B4;}
              input::-moz-placeholder{color: #B4B4B4;}
              input::-webkit-input-placeholder {color: #B4B4B4;}
              input::-ms-input-placeholder {color: #B4B4B4;}
              button{display: block; width: 100%; background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;text-align: center; letter-spacing: 0px;color: #23180A; border: 0 none;height: 40px;}
              .addons-button-clear{cursor: pointer;display: none; background: url("../../../../assets/images/faces/ic_clear_24px.png") no-repeat center center; position: absolute; right:35px; top:60px;width: 30px;  height: 34px;border-radius: 5px; border-top-left-radius: 0;border-bottom-left-radius: 0;}
           }
           .box-filter-bottom{margin-top: 20px; background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border: 1px solid #EFEFEF; padding: 15px;
              .close-filter{display: none; top:15px; right: 10px; position: absolute;cursor: pointer;}
              .title-filter{ font-size: 20px; text-align: left; font-weight:bold; letter-spacing: 0.6px;color: #4B2D15; margin-bottom: 10px;}
              .remove-all{cursor: pointer;background: #FFD311 0% 0% no-repeat padding-box;height: 30px; display: inline-block; padding: 0 10px 0 5px; margin-bottom: 30px;
                img{display: inline-block;}
                span{letter-spacing: 0.39px;color: #4B2D15; font-size:13px; line-height: 30px; display: inline-block;}
              }
              .left-filter{margin-bottom: 10px;
                &:last-child{margin-bottom: 0;}
                .item-top{margin-bottom: 10px;
                  span.category{color: #9F6A28; font-size:17px;}
                  span.view-all{cursor: pointer;color: #1A0DAB; font-size:13px; float: right;}
                }
                .item-checkbox{
                   input{display:none;}
                   input + label{cursor: pointer;background: url("../../../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block; background-size: cover;}
                   input:checked + label{cursor: pointer;background: url("../../../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block;background-size: cover;}
                   input + label + span{display:inline-block; top: -10px; padding-left: 5px; position: relative;font-size:13px;}
                }
              }
           }
        }
        .box-pagination{ margin: 10px auto; text-align: center;}
        
        .box-search-custom{text-align:center;display:none;
          input{margin: 15px 0; display: inline-block; text-align: left;letter-spacing: 0px; color: #B4B4B4;background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4;border-radius: 5px; height: 40px; padding: 0 30px 0 10px;width: calc(100% - 117px);}
          input::placeholder{color: #B4B4B4;}
          input::-moz-placeholder{color: #B4B4B4;}
          input::-webkit-input-placeholder {color: #B4B4B4;}
          input::-ms-input-placeholder {color: #B4B4B4;}
          button{display: inline-block; background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;text-align: center; letter-spacing: 0px;color: #23180A;padding: 10px;  border: 0 none;height: 40px;position: relative;left: -10px;}
          .addons-button-clear{cursor: pointer;display: none; background: url("../../../../assets/images/faces/ic_clear_24px.png") no-repeat center center; position: absolute; right: 27%; top:17px;width: 30px;  height: 34px;border-radius: 5px; border-top-left-radius: 0;border-bottom-left-radius: 0;}
          .icon-filter{cursor: pointer;display: inline-block;text-align:center;position:relative; top:11px;
            &.icon-filter-point:before{background: #D63131 0% 0% no-repeat padding-box;border: 1px solid #FFFFFF;width: 12px;height: 12px;content: ""; position: absolute; border-radius: 50%; right:0;}
            span{display: block;font-size:14px;}
          }
        }
        .box-lesson-top{margin-bottom: 20px;
            .title{text-align: left;font-weight: bold; font-size: 20px;letter-spacing: 0px;color: #4B2D15;text-transform: uppercase; display: inline-block; }
        }
        .box-lesson-content{
            .box-parent-lesson{margin-bottom:30px;
                .box-info{margin-bottom: 10px;
                    .avatar{vertical-align: inherit;width: 40px; height: 40px; display: flex;float: left; border-radius: 50%;overflow: hidden;
                        img{max-width:100%; height: auto; margin: auto;}
                    }
                    .item-info{display: inline-block;margin-left:10px;
                        span.fullname{display:block;color:#4B2D15; font-size:14px;font-weight: 400;}
                        span.subjects{display: inline-block;color:#3A9F00;font-size:14px; padding-right:20px;font-weight: 400;}
                        span.grades{display: inline-block;color:#9F6A28;font-size:14px;font-weight: 400;}
                    }
                }
                .box-item-lesson{border-radius: 5px; position: relative; height: 125px; overflow: hidden; display:flex;justify-content: center;align-items:center;box-shadow: 0px 3px 6px #00000029;
                  .overlay{width: 100%; position: absolute;height:100%; background: transparent linear-gradient(180deg, #FAFAFA00 0%, #EFDAC934 0%, #9F6A28 100%) 0% 0% no-repeat padding-box; cursor: pointer;}
                  a{display: block;width: 100%; height: 100%;
                    img{max-width: 100%; height: 100%; display: block; margin: 0 auto;object-fit: contain;}
                  }
                  .item-title{ position: absolute; bottom:10px;padding: 0 10px;width: 100%;
                    span{color: #fff; font-weight: 400;}
                  }
                }
                .item-social{margin-top:10px; display: table; width:100%;
                  span { display: table-cell;  width: 33.33%;font-size:13px;
                    i{color:#4B2D15; font-size:13px;
                        &:before{padding-right: 5px;}
                        img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
                    }
                    i.like{cursor: pointer;}
                  }
                }
            }
            .view-more.mobile{display: none;}
            .no-data{text-align: center; margin: 15px 0;color: #9F6A28; font-size:15px;}
        }
    }
}
@media (max-width: 1366px){
    .content.front.in-page{
        .box-lesson{
            .box-lesson-content{
                .view-more.mobile{ display: none; }
            }
        }
    }
}
@media (max-width: 1024px){
    .content.front.in-page{
        .box-lesson{
            .box-lesson-content{
                .view-more.mobile{ display: none; }
            }
        }
    }
}
@media (max-width: 991px){
    .content.front.in-page{
        .box-lesson{
            .box-filter{
              &.collapse-filter{visibility: hidden; position: fixed; top: 0; left: 0; padding: 0; z-index: 9999; height: 100%;overflow-y:scroll;overflow-x:hidden;
                &.open-collapse{visibility: visible; width: 100%;height: 100%; transform: translate3d(0, 0, 0); 
                  .box-overlay-filter{display: block;transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
                  .box-filter-bottom{border:0;z-index: 999; transform: translate3d(0, 0, 0);transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
                }
                .box-filter-bottom{height: 100%;  width: 265px; transform: translate3d(-265px, 0, 0);transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
              }
              .box-filter-top{display: none;}
              .box-filter-bottom{margin: 0;background: #FBF4D2 0% 0% no-repeat padding-box; position: fixed; overflow: auto;
                .close-filter{display: block;}
                .item-top{
                  span.category{color: #9F6A28; font-size:15px; font-weight: bold;}
                  span.view-all{color: #1A0DAB; font-size:13px; float: right; cursor:pointer;}
                }
              }
            }
            .box-search-custom{display: block;}
            .box-lesson-top{
                .view-more{display: none;}
            }
            .box-lesson-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-lesson{width: 50%;}
            }
        }
    }
}
@media (max-width: 768px){
    .content.front.in-page{
        .box-lesson{
          .box-lesson-top{
              .title{font-size:20px;}
              .view-more{display: none;}
          }
          .box-lesson-content{
              .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
          }
          .box-lesson-search{
              .input-group{width: 100%;
                  input{width: 100%;}
              }
          } 
        }
    }
}
@media (max-width: 560px){
    .content.front.in-page{
        .box-lesson{
            .box-lesson-top{
              .title{font-size:18px;}
                // .view-more{display: none;}
            }
            .box-lesson-content{
                // .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-lesson{width: 100% !important;
                    .box-item-lesson{height: 150px;}
                }
            }
            .box-lesson-search{
                .input-group{width: 100%;
                    input{width: 100%;}
                }
            } 
        }
    }
}
@media (max-width: 375px){
    .content.front.in-page{
        .box-lesson{
            .box-lesson-top{
                .title{font-size:18px;}
                .view-more{display: none;}
            }
            .box-lesson-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-lesson{width: 100%;
                    .box-item-lesson{height: 150px;}
                }
            }
            .box-lesson-search{
                .input-group{width: 100%;
                    input{width: 100%;}
                }
            } 
        }
    }
}
</style>




// WEBPACK FOOTER //
// infinite.vue?652d7b89